import CustomLink from "../components/CustomLink";
import Heading from "../components/Heading";
import Layout from "../components/Layout";
import styles from "./ErrorPage.module.css";

export default function ErrorPage({ coreData, pathName }) {
  if (!coreData) {
    return (
      <div className={styles.ErrorMessage}>
        <Heading>Error</Heading>
        <p className={styles.text}>
          Sorry, this page cannot be rendered, please click&nbsp;
          <CustomLink href="/">here</CustomLink> to go home.
        </p>
      </div>
    );
  }
  return (
    <Layout coreData={coreData} theme="light" pathName={pathName}>
      <div className={styles.ErrorMessage}>
        <Heading>Page not found</Heading>
        <p className={styles.text}>
          Sorry, this page doesn&apos;t seem to exist, please click&nbsp;
          <CustomLink href="/">here</CustomLink> to go home.
        </p>
      </div>
    </Layout>
  );
}
